import { post } from '../../shared/utils/fetch.util'

// export const getEvidentUiUrl = id => post(`/v2/users/${id}/evident`)
export const getIdCheckrUiUrl = id => post(`/v3/users/${id}/idcheckr`)
export const runBackgroundCheck = id =>
  post(`/v3/users/${id}/backgroundCheck`, {})
// export const runBackgroundCheck = id =>
//   post(`/v2/users/${id}/backgroundCheck`, {})
